// extracted by mini-css-extract-plugin
export default {"account_details":"settingsDetails_account_details__Wp9O8"};